export default __webpack_public_path__ + "static/media/square.67ee1c40.jpg";